//@flow
import * as React from 'react';
import { themr, type ThemeType } from 'react-css-themr';

import { SlotType } from 'common/enums/SlotEnum';
import theme from './SlotsSummary.scss';
import { translate, type TFunction } from 'react-i18next';

import type { MultiDaySlot } from 'common/models/internal/MultiDaySlot';
import type { List } from 'immutable';
import _ from 'lodash';
import entityIds from 'common/tests/entity/entityIds.json';

type Props = {
    theme: ThemeType,
    slots: List<MultiDaySlot>,
    deriveSlotType: (Array<MultiDaySlot>, t) => string,
    showEverydaySlots: boolean,
    isBreaksWithOffset: boolean,
    t: TFunction
};
const slotsSummaryFactory = ({
    SummaryComponent,
    options = { undecorated: false }
}) => {
    class SlotsSummary extends React.Component<Props> {
        renderSlotType(slotType: $Values<typeof SlotType>) {
            const { title } = this.props;
            if (title) {
                return title;
            }
            return this.props.t(`slotProperties.type.${slotType}`);
        }

        renderCustomDaysSummary() {
            const { slots, theme, t, isBreaksWithOffset } = this.props;
            const slotElements = slots.map(slot => {
                return (
                    <div
                        key={slot.dayOfWeek}
                        className={theme.slotsForDayWrap}
                        testId={_.camelCase(
                            `${entityIds.slots}_${slot.dayOfWeek}`
                        )}
                    >
                        <span className={theme.dayOfWeek}>
                            {t(`days.${slot.dayOfWeek}`)}
                        </span>
                        <SummaryComponent
                            theme={theme}
                            t={t}
                            data={slot}
                            isBreaksWithOffset={isBreaksWithOffset}
                        />
                    </div>
                );
            });
            return slotElements;
        }

        render() {
            const { slots, deriveSlotType, theme } = this.props;
            if (!slots || slots.size === 0) {
                return null;
            }
            const slotType = deriveSlotType(slots.toArray());
            return (
                <div className={theme.contentWrap}>
                    <span className={theme.slotType}>
                        {this.renderSlotType(slotType)}
                    </span>
                    <div className={theme.timeSlotsWrap}>
                        {this.renderCustomDaysSummary()}
                    </div>
                </div>
            );
        }
    }

    return options.undecorated
        ? SlotsSummary
        : translate('entityManagement')(
              themr('SlotsSummary', theme)(SlotsSummary)
          );
};

export { slotsSummaryFactory };
export default slotsSummaryFactory;
